module.exports = __webpack_public_path__ + "img/iconIsReaded.5c74b0fc.svg";